import React from 'react';
import propTypes from 'prop-types';

// derives up to two uppercase letters from a carrier's name for use as an
// avatar when no icon is set on the record
function getInitials(name) {
  if (!name) return '?';
  const parts = String(name)
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * circular initials avatar shown in the carrier sidebar when the carrier
 * record has no `carrierIcon` set.
 * @param name - carrier display name
 * @param size - avatar side length in px (default 32)
 */
export default function CarrierInitialsAvatar({ name, size = 32 }) {
  return (
    <span
      aria-hidden
      className='flex shrink-0 items-center justify-center rounded-full bg-primary-light text-primary-darkened font-semibold'
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {getInitials(name)}
    </span>
  );
}

CarrierInitialsAvatar.propTypes = {
  name: propTypes.string.isRequired,
  size: propTypes.number
};
